export default function swDev() {
  let swUrl = `${process.env.PUBLIC_URL}/sw.js`; // url of public  sw file
  navigator.serviceWorker.register(swUrl).then((response) => {
    console.log(response);
  });
}
